<template>
  <div class="card-text grid-field-colour">
    <div
      v-if="isValidHexColour(value)"
      class="grid-field-colour__swatch"
      :style="{ backgroundColor: value }"
    ></div>
    <div class="grid-field-colour__text">{{ value }}</div>
  </div>
</template>

<script>
import { isValidHexColour } from '@baserow/modules/core/utils/string'

export default {
  name: 'RowCardFieldColour',
  height: 16,
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    isValidHexColour,
  },
}
</script>
